import { useContext } from 'react';

import { LoadingContext } from '../context/Loading.context.js';

export const useLoading = () => useContext(LoadingContext);
